<template>
    <div>
        <Main title="Notifications" subtitle="Overall User Notifications">
            <template v-slot:table>
                <v-app>
                    <TableLoading cols="4" v-if="loading"></TableLoading>

                    <div class="table-responsive mt-4" v-if="!loading">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>Notification</th>
                                <th>Notified At</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="notification in userNotifications" :key="notification.id" class="notification-row" :class="!notification.read_at ? 'bg-gray-100' : ''">
                                <td>
                                    <i v-if="notification.data.link" class="fas fa-external-link-alt mr-1"></i>
                                    <span @click.prevent="openLink(notification)" :class="[notification.data.link ? 'cursor-pointer' : '']">{{ notification.data.message }}</span>
                                </td>
                                <td>{{ notification.created || '' }}</td>
                                <td>
                                    <span>{{ notification.read_at ? 'Read' : 'Not read' }}</span>
                                </td>
                                <td class="btn-td">
                                    <div class="btn-group" role="group" aria-label="User Actions">

                                        <v-tooltip top v-if="!notification.read_at">
                                            <template v-slot:activator="{ on }">
                                                <button
                                                    v-on="on"
                                                    @click="markAsRead(notification)"
                                                    class="btn btn-info">
                                                    <i class="fas fa-eye"></i>
                                                </button>
                                            </template>
                                            <span>Mark as Read</span>
                                        </v-tooltip>

                                        <v-tooltip top v-if="notification.read_at">
                                            <template v-slot:activator="{ on }">
                                                <button
                                                    v-on="on"
                                                    @click="markAsUnread(notification)"
                                                    class="btn btn-info">
                                                    <i class="fas fa-eye-slash"></i>
                                                </button>
                                            </template>
                                            <span>Mark as Unread</span>
                                        </v-tooltip>

                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <button
                                                    v-on="on"
                                                    @click="removeNotification(notification)"
                                                    class="btn btn-danger">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </template>
                                            <span>Remove notification</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </v-app>
            </template>
        </Main>
    </div>
</template>

<script>

import mixins from "../../mixin";
import Main from "../../components/Main";
import TableLoading from "../../components/general/TableLoading";
import api from "../../api/notifications/notifications";

export default {
    name: "UserNotifications",
    mixins: [mixins],
    data: () => ({
        loading: true,
        userNotifications: [],

        notifications: [],
        alert: false,
    }),
    components: {
        Main,
        TableLoading
    },
    methods: {
        async fetchData() {
            await api.getUserNotifications()
                .then(res => {
                    this.userNotifications = res.data
                    this.loading = false
                })
        },
        openLink(notification) {
            if (notification.data.link) {
                window.open(
                    location.href = notification.data.link,
                    '_blank'
                );

            }
        },
        async markAsRead(notification, redirect = false) {
            await api.notificationMarkAsRead({
                id: notification.id
            })
            .then(res => {
                this.fetchData()
                if (notification.data.link && redirect) {
                    window.open(
                        location.href = notification.data.link,
                        '_blank'
                    );
                }
            })
        },
        async removeNotification(notification) {
            await api.notificationRemove({
                id: notification.id
            })
            .then(res => {
                this.fetchData()
            })
        },
        async markAsUnread(notification) {
            await api.notificationMarkAsUnread({
                id: notification.id
            })
                .then(res => {
                    this.fetchData()
                })
        },
    },
    created() {
        this.fetchData()
    },
    watch: {
        '$store.getters.getUserId' : function (val) {
            if (val) {
                window.Echo.private('notifications-' + this.$store.getters.getUserId)
                    .listen('Frontend\\Notification\\NewNotification', (e) => {
                        this.fetchData()
                    })
                    .listen('Frontend\\Notification\\NotificationUpdated', (e) => {
                        this.fetchData()
                    })
            }
        }
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

button:focus {
    outline:0;
}

.btn-info {
    border-radius: 5px 0px 0px 5px !important;
}

</style>